<template>
  <fragment>
    <!-- End Infobar Setting Sidebar -->
    <div class="row">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-header row">
            <div class="col">
              <h5 class="card-title mb-0" >Filtri</h5>
              
            </div>
          </div>
        
          <div class="card-body">
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  v-model="query"
                  class="form-control mb-2"
                  placeholder="Comunicazione"
                />
              </div>
            </div>
             

            <div class="row">
              <div class="col text-right">
               
                <div class="btn-group"  >
                <button class="btn btn-primary-rgba mr-2" v-on:click="loaddata">
                  <i class="feather icon-filter mr-2"></i>Ricerca
                </button>
                <button class="btn btn-danger-rgba" v-on:click="resetdata">
                  <i class="feather icon-delete mr-2"></i>Elimina filtro
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>

        <div class="card m-b-30">
          <div class="card-body">
          <router-link class="btn btn-sm btn-primary-rgba"  :to="{name:'route-newsletter-edit', params:{'id':'00000000-0000-0000-0000-000000000000'}}">
                                <i class="feather icon-plus"></i> Nuova comunicazione
                            </router-link>
                            <hr />
            <table

              ref="table"
              id="list-newsletter-table"
              class="table w-100"
            ></table>
          </div>
        </div>
      </div>
    </div>
   
    <!-- /.col -->
  </fragment>
</template>

<script>
export default {
  computed: {},
  components: {},
  data() {
    return {
    
      query: "",
    
    };
  },
  name: "newsletterList",
  beforeMount() {
    
  },

  mounted() {
    var me = this;
    if (localStorage.getItem("newsletter-list-query"))
      me.query = localStorage.getItem("newsletter-list-query");
  

    setTimeout(this.loaddata, 200);
  },
  methods: {
    edit: function (id) {
      this.$router.push({ name: "route-newsletter-edit", params: { id: id } });
      return false;
    },
    resetdata() {
      this.query = "";
     
      this.loaddata();
    },
    loaddata: function () {
    
      //console.log("usidebar",this.$refs.usidebar.loaddata);
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-newsletter-table")) {
        $("#list-newsletter-table").DataTable().destroy();
      }

      var $table = $("#list-newsletter-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/newsletter/list",
          type: "POST",
          data: function (d) {
            localStorage.setItem("newsletter-list-query", me.query);
            
            d.search.value = me.query;
            
            d.filters = [
             
            ];
            d.tago;

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "newsletterId",
            name: "newsletterId",
            title: "Oggetto Comunicazione",
            render: function (data, type, row, meta) {
              return row.subject;
            },
          },
          {
            className: "text-right",
            data: "newsletterId",
            name: "newsletterId",
            title: "Azioni",
            render: function (data, type, row, meta) {
             
              
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action" data-url="newsletter/${data}"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],
      });

   
    },
  },
};
</script>
